import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import ModalDisable2fa from 'components/user/profile/modal/two_factor/disable';

const DisableTwoFactorModal = ({ refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      className="no-wrap"
      variant="outlined"
      onClick={() =>
        addModal(
          <ModalDisable2fa
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.user.two_factor.disabled');
            }}
            handleClose={() => {
              removeModal();
            }}
          />
        )
      }
    >
      <FormattedMessage id="button.two_factor.disable" />
    </Button>
  );
};

export default DisableTwoFactorModal;
